import axios from "axios";

// In produzione il frontend è servito dallo stesso processo Node del backend
// → chiamate API same-origin con prefisso /api.
// In sviluppo locale con `npm start`, puoi impostare REACT_APP_BACKEND_URL
// a http://localhost:3000 (o dove gira Fastify).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 60000 });

export const api = {
  ingest: (url, resource_type) =>
    client.post("/resources/ingest", { url, resource_type }).then((r) => r.data),
  list: (params = {}) =>
    client.get("/resources", { params }).then((r) => r.data),
  keywords: () => client.get("/resources/keywords").then((r) => r.data),
  get: (id) => client.get(`/resources/${id}`).then((r) => r.data),
  update: (id, payload) =>
    client.put(`/resources/${id}`, payload).then((r) => r.data),
  remove: (id) => client.delete(`/resources/${id}`).then((r) => r.data),
  reprocess: (id) =>
    client.post(`/resources/${id}/reprocess`).then((r) => r.data),
};

export const RESOURCE_TYPES = [
  { value: "web_page", label: "Pagina Web" },
  { value: "youtube_video", label: "Video YouTube" },
  { value: "x_post", label: "Post X" },
  { value: "instagram_reel", label: "Reel Instagram" },
];

export const TYPE_STYLES = {
  web_page: {
    bg: "bg-sky-50",
    text: "text-sky-800",
    border: "border-sky-200",
    label: "Pagina Web",
  },
  youtube_video: {
    bg: "bg-red-50",
    text: "text-red-800",
    border: "border-red-200",
    label: "YouTube",
  },
  x_post: {
    bg: "bg-zinc-100",
    text: "text-zinc-900",
    border: "border-zinc-300",
    label: "X",
  },
  instagram_reel: {
    bg: "bg-pink-50",
    text: "text-pink-800",
    border: "border-pink-200",
    label: "Instagram",
  },
};

export const STATUS_LABELS = {
  pending: "In coda",
  extracting: "Estrazione…",
  distilling: "Distillazione LLM…",
  ready: "Pronto",
  failed: "Fallito",
};
